export default [
  {
    path: '/rental/report/MY_005/home_rental_charges',
    name: 'MY_005_DailyHomeRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_005_report" */ './DailyHomeRentalCharges.vue'
      )
  },
  {
    path: '/rental/report/MY_005/income_develop',
    name: 'MY_005_DailyIncomeOfDevelopAndSecuity',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_005_report" */ './DailyIncomeOfDevelop.vue'
      )
  },
  {
    path: '/report/report/MY_005/rental_charges',
    name: 'MY_005_MothlyRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_005_report" */ './MothlyRentalCharges.vue'
      )
  },
  {
    path: '/report/report/MY_005/income_others',
    name: 'MY_005_MothlyIncomeOfOthers',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_005_report" */ './MothlyIncomeOfOthers.vue'
      )
  },
  {
    path: '/report/report/MY_005/balance_due_home_rental',
    name: 'MY_005_MothlyBalanceDueListForHomeRental',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_005_report" */ './MothlyBalanceDueListForHomeRental.vue'
      )
  }
]
